import { t } from "i18next";

export const roleOptions: any = [
    {
        value: 'badminton_administrator',
        label: 'Administrador'
    },
    {
        value: 'badminton_manager',
        label: 'Manager'
    },
    {
        value: 'badminton_coach',
        label: 'Coach'
    },
    {
        value: 'badminton_athlete',
        label: 'Athlete'
    }
];